import { useState, useEffect } from "react";
import { FaUser, FaTable, FaBook } from 'react-icons/fa';
import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import { useNavigate } from "react-router-dom";
import Loading from "../loading/loading";
import { useAuth } from "../http/authcontex";
import { viewDashboard } from "../http/api";
import '../common/style.css';
import './dashboard.css';

export default function DashboardComponent() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const authContext = useAuth();
    const [isSidebarOpen, setIsSidebarOpen] = useState(
        localStorage.getItem('sb|sidebar-toggle') === 'true'
    );

    const [dashboard, setDashboard] = useState({
        totalEnrolled: 0,
        prevMonthEnrolled: 0,
        curMonthEnrolled: 0,
        todayEnrolled: 0,
        totalBatch: 0,
        prevMonthBatch: 0,
        curMonthBatch: 0,
        todayBatch: 0,
        totalTrained: 0,
        prevMonthTrained: 0,
        curMonthTrained: 0,
        todayTrained: 0
    });

    useEffect(() => {
        localStorage.setItem('sb|sidebar-toggle', isSidebarOpen);
    }, [isSidebarOpen]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        localStorage.setItem('sb|sidebar-toggle', !isSidebarOpen);
    };

    useEffect(() => {
        setLoading(true);
        viewDashboard()
            .then(response => {
                if (response.status === 200) setDashboard(response.data);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                if (error.response?.status === 401) {
                    authContext.logout();
                    navigate('');
                } else {
                    console.error('Error fetching dashboard:', error);
                }
            });
    }, [authContext, navigate]);

    if (loading) return <Loading />;

    const cards = [
        { title: "Total Enrolled", icon: <FaUser />, value: dashboard.totalEnrolled, bg: "bg-gradient-green" },
        { title: "Prev Month Enrolled", icon: <FaUser />, value: dashboard.prevMonthEnrolled, bg: "bg-gradient-blue" },
        { title: "Cur Month Enrolled", icon: <FaUser />, value: dashboard.curMonthEnrolled, bg: "bg-gradient-teal" },
        { title: "Today Enrolled", icon: <FaUser />, value: dashboard.todayEnrolled, bg: "bg-gradient-gray" },

        { title: "Total Batches", icon: <FaTable />, value: dashboard.totalBatch, bg: "bg-gradient-green" },
        { title: "Prev Month Batches", icon: <FaTable />, value: dashboard.prevMonthBatch, bg: "bg-gradient-blue" },
        { title: "Cur Month Batches", icon: <FaTable />, value: dashboard.curMonthBatch, bg: "bg-gradient-teal" },
        { title: "Today Batches", icon: <FaTable />, value: dashboard.todayBatch, bg: "bg-gradient-gray" },

        { title: "Total Trained", icon: <FaBook />, value: dashboard.totalTrained, bg: "bg-gradient-green" },
        { title: "Prev Month Trained", icon: <FaBook />, value: dashboard.prevMonthTrained, bg: "bg-gradient-blue" },
        { title: "Cur Month Trained", icon: <FaBook />, value: dashboard.curMonthTrained, bg: "bg-gradient-teal" },
        { title: "Today Trained", icon: <FaBook />, value: dashboard.todayTrained, bg: "bg-gradient-gray" },
    ];

    return (
        <div className={`DashboardComponent sb-nav-fixed ${isSidebarOpen ? 'sb-sidenav-toggled' : ''}`}>
            <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
            <div id="layoutSidenav">
                <SideNave isSidebarOpen={isSidebarOpen} />
                <div id="layoutSidenav_content">
                    <main className="bg-light min-vh-100">
                        <div className="container-fluid px-4 py-4">
                            <h2 className="mb-4 text-dark">Dashboard</h2>
                            <div className="row g-4">
                                {cards.map((card, index) => (
                                    <div key={index} className="col-xl-3 col-md-6 d-flex">
                                        <div className={`card text-white shadow border-0 ${card.bg} card-hover flex-fill`}>
                                            <div className="card-body d-flex align-items-center justify-content-between">
                                                <div className="icon me-3">{card.icon}</div>
                                                <div className="text-end">
                                                    <h6 className="mb-1">{card.title}</h6>
                                                    <h3 className="mb-0">{card.value}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
}
